import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/custom/components/organisms/User/Tabs/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })

    const { user_dynamicfields } = dynamicContext
    const history = useHistory()

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 0,
    }
    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setManage({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            console.log(user_dynamicfields, 'userr')
            let dynamicValueAssign = []
            user_dynamicfields.map((item) => {
                item.view_on
                    ? item.view_on.includes('3')
                        ? dynamicValueAssign.push(item)
                        : {}
                    : dynamicValueAssign.push(item)
            })
            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })
            const temp = dynamicValueAssign
                .filter(
                    (item) =>
                        item.name !== 'password' &&
                        item.name !== 'confirm_password' &&
                        item.name !== 'companyname' &&
                        item.for_buyer === 1
                )
                .map((item) => {
                    if (item.name === 'fill_others') {
                        return {
                            ...item,
                            label: '',
                            // placeholder: '',
                        }
                    }
                    return item
                })

            setFieldValue(temp)
        }
    }, [user_dynamicfields])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    data={manage}
                    customInitial={customInitial}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    standalone={global.standalone ? global.standalone : false}
                    creditLabel={global.creditLabel}
                    creditTextChange={global.creditTextChange}
                    loadOff={true}
                    invoiceTab={global.invoiceTab ? global.invoiceTab : false}
                />
            </Layout>
        </>
    )
}

export default UserCommon
